import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"role-class",attrs:{"flat":""}},[(_vm.sameLine)?_c(VCardText,{},[_c('strong',[_vm._v(_vm._s(_vm.$t('role.role')))]),_vm._v(": "+_vm._s(_vm.getRole)+" ")]):_c(VCardText,[_c('strong',[_vm._v(_vm._s(_vm.$t('role.role')))]),_c('br'),_vm._v(" "+_vm._s(_vm.getRole)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }